class CartDrawer extends HTMLElement {
  constructor() {
    super()

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close())
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this))
    this.setHeaderCartIconAccessibility()
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble")
    if (!cartLink) return

    cartLink.setAttribute("role", "button")
    cartLink.setAttribute("aria-haspopup", "dialog")

    if (cartLink.tagName.toLowerCase() === "a") {
      cartLink.addEventListener("click", (event) => {
        event.preventDefault()
        this.open(cartLink)
      })
      cartLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault()
          this.open(cartLink)
        }
      })
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy)
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary')
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role")) this.setSummaryAccessibility(cartDrawerNote)

    setTimeout(() => {
      this.classList.add("animate", "active")
    })

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer")
        const focusElement = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close")
        // Cinturón de seguridad además del arreglo de arriba: si por lo que
        // sea containerToTrapFocusOn sigue sin encontrarse, no romper el
        // resto del script (antes esto tiraba abajo la apertura del drawer).
        if (window.trapFocus && containerToTrapFocusOn) {
          window.trapFocus(containerToTrapFocusOn, focusElement)
        }
      },
      { once: true },
    )

    document.body.classList.add("overflow-hidden")
  }

  close() {
    this.classList.remove("active")
    if (window.removeTrapFocus) {
      window.removeTrapFocus(this.activeElement)
    }
    document.body.classList.remove("overflow-hidden")
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button")
    cartDrawerNote.setAttribute("aria-expanded", "false")

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute("aria-controls", cartDrawerNote.nextElementSibling.id)
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"))
    })

    if (window.onKeyUpEscape) {
      cartDrawerNote.parentElement.addEventListener("keyup", window.onKeyUpEscape)
    }
  }

  renderContents(parsedState) {
    // Blindaje: si la respuesta de /cart/add.js (u otra llamada al carrito) no
    // trae el HTML de alguna sección esperada -por el motivo que sea-, antes
    // esto lanzaba una excepción sin capturar (parsedState.sections[section.id]
    // undefined -> DOMParser sobre "undefined" -> querySelector null ->
    // .innerHTML de null), que abortaba renderContents a mitad, dejaba el
    // drawer sin abrir y burbujeaba como un "Error adding product to cart"
    // aunque el producto sí se hubiera añadido al carrito real. Ahora se
    // avisa por consola y se sigue con el resto en vez de romper todo.
    // BUG REAL (ya existía en el código original, no es cosa mía): la clase
    // "is-empty" la pone Liquid en <cart-drawer> (este propio elemento, "this"),
    // no en ".drawer__inner". Como aquí se comprobaba/quitaba en ".drawer__inner"
    // en vez de en "this", la clase "is-empty" nunca se quitaba tras añadir el
    // primer producto a un carrito vacío. Efecto: open() seguía pensando que el
    // carrito estaba vacío y buscaba el contenedor ".drawer__inner-empty" (que
    // ya no existe en el HTML nuevo, porque el carrito ya tiene productos) ->
    // trapFocus(null, ...) -> "Cannot read properties of null (reading
    // 'querySelectorAll')" -> el drawer se queda en blanco/bloqueado.
    if (this.classList.contains("is-empty")) {
      this.classList.remove("is-empty")
    }
    this.productId = parsedState.id
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id)

      if (!sectionElement) return

      const sectionHTML = parsedState.sections && parsedState.sections[section.id]
      if (!sectionHTML) {
        console.warn(
          `cart-drawer: la respuesta no incluyó HTML para la sección "${section.id}"; se omite su actualización.`,
          parsedState
        )
        return
      }
      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector)
    })

    setTimeout(() => {
      const overlay = this.querySelector("#CartDrawer-Overlay")
      if (overlay) overlay.addEventListener("click", this.close.bind(this))
      this.open()
      // "Combínalo con": el HTML nuevo trae #CartDrawer-Upsell con los
      // product_id actualizados, hay que volver a pedir recomendaciones
      // (ver assets/cart-upsell.js). Llamada protegida: si ese script no
      // ha cargado todavía o no existe, no rompe nada más del drawer.
      if (typeof window.initCartUpsell === "function") {
        window.initCartUpsell()
      }
    })
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const el = new DOMParser().parseFromString(html, "text/html").querySelector(selector)
    return el ? el.innerHTML : ""
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
    ]
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector)
  }

  setActiveElement(element) {
    this.activeElement = element
  }

  removeCartItem(variantId) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0
      })
    })
    .then(response => response.json())
    .then(data => {
      this.renderContents(data);
    })
    .catch(error => {
      console.error('Error removing item:', error);
    });
  }
}

if (!customElements.get("cart-drawer")) customElements.define("cart-drawer", CartDrawer)

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ]
  }
}

if (!customElements.get("cart-drawer-items")) customElements.define("cart-drawer-items", CartDrawerItems)
